import { useEffect } from "react";
import { setSeo } from "@/utils/seo";
import { Link } from "react-router-dom";
import { Navbar, Footer } from "@/components/Layout";

export default function Termini() {
  useEffect(() => {
    setSeo(
      "Termini di utilizzo | HairHelp",
      "Termini di utilizzo di HairHelp: un servizio gratuito di orientamento ed esperienza sui sistemi capillari, che offre consigli pratici e non pareri medici."
    );
  }, []);

  return (
    <div className="min-h-screen bg-ivory font-manrope text-charcoal">
      <Navbar />
      <section className="mx-auto max-w-3xl px-6 py-16 md:py-24" data-testid="terms-page">
        <h1 className="font-editorial text-3xl font-semibold text-foreground sm:text-4xl" data-testid="terms-title">
          Termini di utilizzo
        </h1>
        <div className="mt-8 space-y-6 text-base leading-relaxed text-muted-foreground">
          <p>
            Utilizzando HairHelp accetti i presenti termini di utilizzo. Ti invitiamo a leggerli
            con attenzione.
          </p>

          <h2 className="pt-2 font-editorial text-lg font-bold text-foreground">Natura del servizio</h2>
          <p>
            HairHelp è un servizio gratuito di orientamento e condivisione di esperienza dedicato al
            mondo delle protesi e dei sistemi capillari. Offriamo consigli pratici basati
            sull'esperienza reale nell'utilizzo di questi sistemi.
          </p>

          <h2 className="pt-2 font-editorial text-lg font-bold text-foreground">Nessun parere medico</h2>
          <p>
            I contenuti e le risposte forniti da HairHelp hanno finalità puramente informative e
            pratiche. Non costituiscono parere medico, diagnosi o trattamento e non sostituiscono in
            alcun modo la consulenza di medici, dermatologi o altri professionisti qualificati. Per
            problematiche di natura sanitaria rivolgiti sempre a un professionista.
          </p>

          <h2 className="pt-2 font-editorial text-lg font-bold text-foreground">Uso dei contenuti</h2>
          <p>
            I contenuti del sito appartengono a HairHelp e non possono essere riprodotti senza
            autorizzazione. Ti impegni a utilizzare il servizio in modo lecito e corretto.
          </p>

          <h2 className="pt-2 font-editorial text-lg font-bold text-foreground">Contatti</h2>
          <p>
            Per qualsiasi domanda relativa a questi termini puoi scriverci a{" "}
            <a href="mailto:admin@hairhelp.studio" className="font-semibold text-sage underline" data-testid="terms-contact-link">
              admin@hairhelp.studio
            </a>.
          </p>
        </div>
        <Link
          to="/fai-una-domanda"
          data-testid="terms-cta"
          className="mt-10 inline-block rounded-full bg-sage px-6 py-3 text-sm font-bold uppercase tracking-wide text-white transition-transform duration-300 ease-out hover:scale-105 active:scale-95"
        >
          Chiedici un consiglio →
        </Link>
      </section>
      <Footer />
    </div>
  );
}
